import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Donate.css";
import logo from "./unnamed.png";
import { useConfig } from "../../context/ConfigContext";

export default function WoodenSpoonDonate() {
  const { config } = useConfig();
  const API_URL = config.REACT_APP_API_URL;
  const API_KEY = config.REACT_APP_API_KEY;

  const [amount, setAmount] = useState(0);
  const [displayAmount, setDisplayAmount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const revealRef = useRef([]);

  useEffect(() => {
    const fetchAmount = async () => {
      try {
        const res = await fetch(API_URL, {
          headers: { "Api-Key": API_KEY },
        });
        const data = await res.json();
        const total =
          Number(
            data?.donated?.amountDonated ??
              data?.amount ??
              data?.donatedAmount ??
              0
          ) || 0;
        setAmount(total);
        setDisplayAmount(total);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(true);
        setLoading(false);
      }
    };

    fetchAmount();
  }, [API_URL, API_KEY]);


  useEffect(() => {
    if (!loading && !error) {
      let start = 0;
      const duration = 3000;
      const end = amount;
      const stepTime = 16;
      const increment = (end - start) / (duration / stepTime);
      const counter = setInterval(() => {
        start += increment;
        if (start >= end) {
          start = end;
          clearInterval(counter);
        }
        setDisplayAmount(Math.round(start));
      }, stepTime);
      return () => clearInterval(counter);
    }
  }, [loading, error, amount]);

  useEffect(() => {
    const els = revealRef.current;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add("show");
      });
    }, { threshold: 0.15 });
    els.forEach((el) => el && obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section className="donations-page">
      <div className="header">
        <h1>Support Wooden Spoon</h1>
        <p className="intro">Together we honour Beth by standing with Wooden Spoon to give hope, opportunity and joy to more children.</p>
      </div>

      <div className="cards">
        <article className="card reveal" ref={(el) => (revealRef.current[0] = el)}>
          <h2 className="box-header">About Wooden Spoon</h2>
          <p>
Wooden Spoon is a charity rooted in the heart of the rugby community, transforming the lives of children and young people facing disadvantage, disability or additional needs. Guided by the values of teamwork, compassion and determination, they fund life-changing projects across the UK - from sensory rooms and adapted playgrounds to specialist equipment, education spaces and community programmes that give children the chance to thrive.
Their work mirrors everything Bethany believed in: inclusion, strength, fairness and the idea that every child deserves the same opportunities, no matter their circumstances.
By supporting our memorial match, you become part of that mission. Every raffle ticket, donation and moment of support helps Wooden Spoon reach more children, build more safe and joyful spaces, and bring hope into the lives of families who need it most.    
          </p>
        </article>

        <article className="card reveal" ref={(el) => (revealRef.current[1] = el)}>
          <h2 className="box-header">How Your Donations Help</h2>
          <ul className="help-list">
            <li>Funding sensory rooms that give children with additional needs a calm, safe space to relax, regulate and feel understood.</li>
            <li>Creating accessible playgrounds where every child — regardless of ability — can play, laugh and belong.</li>
            <li>Providing specialist equipment that supports independence, mobility and confidence for children who need extra help.</li>
            <li>Building and improving education spaces, giving children places to learn, communicate and grow in ways that meet their individual needs.</li>
            <li>Supporting community projects that lift families during their toughest times and bring vital services closer to home.</li>
            <li>Opening doors to new opportunities, helping children experience joy, resilience and hope through rugby values and community spirit.</li>
            <li>Changing futures, one project at a time — giving children the chance to thrive in the world Beth fought so hard to make fairer and kinder.</li>
          </ul>
          <div className="cta-row">
            <Link to="https://square.link/u/wcHJPHfK?src=sheet" target="_blank" rel="noreferrer" className="btn donate">Donate Now</Link>
          </div>
        </article>

        <article className="card total reveal" ref={(el) => (revealRef.current[2] = el)}>
          <h2 className="box-header">Total Raised</h2>
          {loading && <p className="faded">Loading total…</p>}
          {error && <p className="faded error">Unable to load the total right now.</p>}
          {!loading && !error && (
            <p className="amount">£{displayAmount.toLocaleString()}</p>
          )}
          <p className="note">Thank you for every single donation — your support keeps Beth’s legacy alive.</p>
          <img src={logo} alt=""></img>
        </article>
      </div>
    </section>
  );
}